module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    attrs: {
      "transform": "translate(1980, 155), scale(0.79, 0.79)"
    }
  }, [_c('g', {
    class: _vm.data,
    attrs: {
      "id": "girl3"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20.7538628,235.869673 C20.6035101,239.295322 19.2425775,241.189958 16.8162679,245.158028 C13.9853646,249.787786 13.9877114,258.250704 10.7797417,265.301292 C11.5706881,266.971204 16.7615588,264.041466 17.9001842,261.203684 C19.0388096,258.365901 19.9078633,256.05808 20.2931346,255.343368 C20.678406,254.628656 21.5696578,254.708004 21.8176035,255.403017 C22.0655492,256.09803 21.846371,281.064726 22.3624057,282.305561 C22.8784403,283.546396 25.9815271,283.692248 26.5632979,282.444124 C27.1450687,281.195999 27.8004277,261.458012 28.0819688,260.938436 C28.3635099,260.41886 29.0365738,260.695605 29.3145686,260.979092 C29.5925635,261.262579 28.3179516,282.328417 28.7525787,283.128242 C29.1872058,283.928067 32.3985797,283.897872 32.7693235,283.26073 C33.1400672,282.623588 34.0343115,261.61243 34.4005566,261.146848 C34.7668018,260.681266 35.4712627,260.757992 35.7446502,261.191182 C36.0180378,261.624372 34.4828634,281.834936 34.9504602,282.720766 C35.4180569,283.606596 38.5263527,283.722856 38.844973,282.849223 C39.1635934,281.975589 40.548996,261.645612 40.8610248,261.35994 C41.1730536,261.074269 41.5771124,261.115278 41.8541873,261.392699 C42.1312622,261.67012 41.8742017,276.88002 42.339738,277.72249 C42.8052742,278.56496 45.1508658,278.837763 45.5353587,277.827894 C45.9198517,276.818026 45.6282794,239.710297 45.7503099,237.655532 C46.1569846,230.807893 41.6676812,223.50566 34.0620904,223.440108 C26.4564996,223.374556 21.0767329,228.513377 20.7538628,235.869673 Z",
      "id": "girl3_right_hand",
      "fill": "#AFD485",
      "transform": "translate(28.277758, 253.586760) rotate(9.000000) translate(-28.277758, -253.586760) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39.4216177,180.702147 L39.4216177,180.702147 L39.4216177,180.702147 C46.3251771,180.702147 51.9216177,186.298587 51.9216177,193.202147 L51.9216177,237.202147 L51.9216177,237.202147 C51.9216177,244.105706 46.3251771,249.702147 39.4216177,249.702147 L39.4216177,249.702147 L39.4216177,249.702147 C32.5180583,249.702147 26.9216177,244.105706 26.9216177,237.202147 L26.9216177,193.202147 L26.9216177,193.202147 C26.9216177,186.298587 32.5180583,180.702147 39.4216177,180.702147 Z",
      "id": "girl3_right_arm_bottom",
      "fill": "#AFD485",
      "transform": "translate(39.421618, 215.202147) rotate(9.000000) translate(-39.421618, -215.202147) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M52.4838955,132.73017 C59.3024606,133.810125 63.9545236,140.21314 62.874569,147.031705 L55.2092802,195.428434 C54.1293256,202.246999 47.7263102,206.899062 40.9077451,205.819107 C34.08918,204.739153 29.437117,198.336137 30.5170717,191.517572 L38.1823604,143.120844 C39.2623151,136.302278 45.6653304,131.650215 52.4838955,132.73017 Z",
      "id": "girl3_right_arm_top",
      "fill": "#AFD485"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M66.5,324 L66.5,324 L66.5,324 C73.4035594,324 79,329.596441 79,336.5 L79,397 L54,397 L54,336.5 L54,336.5 C54,329.596441 59.5964406,324 66.5,324 Z",
      "id": "girl3_right_leg_bottom",
      "fill": "#AFD485"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "girl3_right_leg_top",
      "fill": "#AFD485",
      "x": "54",
      "y": "235",
      "width": "25",
      "height": "114",
      "rx": "12.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.6360045,394.224213 C34.0697408,391.909668 42.3226705,391.606445 43.3226705,395.120605 C43.7088207,396.477599 43.3226705,400.263184 43.3226705,402.846191 C43.3226705,405.429199 43.9271626,415.222656 48.4725728,419.583984 C53.017983,423.945312 61.5106799,427.036208 64.2225728,428.046143 C63.539357,430.181769 57.473773,431.164003 53.5162379,432.062794 C30.9428539,424.908111 31.6195807,395.865071 32.6360045,394.224213 Z",
      "id": "girl3_right_shoe_6",
      "fill": "#6D8C4A",
      "transform": "translate(48.236286, 412.271875) scale(-1, 1) translate(-48.236286, -412.271875) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39.0093139,397 C38.9676447,397 25.8772624,397 23.0434936,397 C23.1645874,401.157837 22.494199,436.388112 23.1645874,443.210937 C28.7325185,443.210937 71.8791106,443.210937 78.877712,443.210937 C79.2472106,440.14087 81.1081312,431.203427 68.1168759,427.465242 C66.7688982,428.503277 65.313552,429.608837 60.6245692,431.203427 C40.6577514,426.166016 39.0542358,402.28418 39.0093139,397 Z",
      "id": "girl3_right_shoe_5",
      "fill": "#80A259",
      "transform": "translate(51.021747, 420.105469) scale(-1, 1) translate(-51.021747, -420.105469) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60.9041154,438.943197 C57.3170686,438.943197 26.052665,438.900386 20.8210519,438.900386 C20.858616,439.419877 20.858616,440.86511 20.8210519,443.236084 C58.7636275,443.264624 78.1678613,443.278895 79.0337533,443.278895 C79.3323052,440.798305 80.5516992,432.284289 70.3831174,428.350919 C67.5858899,427.520181 61.2934521,432.775964 60.9041154,438.943197 Z",
      "id": "girl3_right_shoe_4",
      "fill": "#CDF1A5",
      "transform": "translate(50.029544, 435.771527) scale(-1, 1) translate(-50.029544, -435.771527) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39.1843452,427.513343 C40.0873308,426.026122 45.9015481,423.518416 48.0254684,423.213991 C48.9091613,423.087329 49.8238904,423.829053 49.6997456,424.729312 C47.0281159,425.250636 41.9325169,427.752825 41.0505016,428.750597 C40.1684863,429.748369 38.2813595,429.000564 39.1843452,427.513343 Z",
      "id": "girl3_right_shoe_3",
      "fill": "#CDF1A5",
      "transform": "translate(44.328372, 426.202587) scale(-1, 1) translate(-44.328372, -426.202587) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M46.2055875,422.996753 C47.1085732,421.509532 52.9227904,419.001825 55.0467107,418.6974 C55.9304036,418.570739 56.8451327,419.312462 56.7209879,420.212722 C54.0493582,420.734046 48.9537592,423.236235 48.0717439,424.234007 C47.1897286,425.231779 45.3026018,424.483974 46.2055875,422.996753 Z",
      "id": "girl3_right_shoe_2",
      "fill": "#CDF1A5",
      "transform": "translate(51.349614, 421.685997) scale(-1, 1) translate(-51.349614, -421.685997) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M50.2418741,416.984118 C51.1448598,415.496897 56.9590771,412.98919 59.0829974,412.684765 C59.9666903,412.558104 60.2654495,413.566686 60.1413047,414.466946 C57.469675,414.98827 52.9900459,417.2236 52.1080306,418.221372 C51.2260153,419.219144 49.3388885,418.471339 50.2418741,416.984118 Z",
      "id": "girl3_right_shoe_1",
      "fill": "#CDF1A5",
      "transform": "translate(55.085653, 415.675021) scale(-1, 1) translate(-55.085653, -415.675021) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M106.5,324 L106.5,324 L106.5,324 C113.403559,324 119,329.596441 119,336.5 L119,397 L94,397 L94,336.5 L94,336.5 C94,329.596441 99.5964406,324 106.5,324 Z",
      "id": "girl3_left_leg_bottom",
      "fill": "#AFD485"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M106.5,235 L106.5,235 L106.5,235 C113.403559,235 119,240.596441 119,247.5 L119,336.499288 L119,336.499288 C119,343.402847 113.403559,348.999288 106.5,348.999288 L106.5,348.999288 L106.5,348.999288 C99.5964406,348.999288 94,343.402847 94,336.499288 L94,247.5 L94,247.5 C94,240.596441 99.5964406,235 106.5,235 Z",
      "id": "girl3_left_leg_top",
      "fill": "#AFD485"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72.6360045,394.224213 C74.0697408,391.909668 82.3226705,391.606445 83.3226705,395.120605 C83.7088207,396.477599 83.3226705,400.263184 83.3226705,402.846191 C83.3226705,405.429199 83.9271626,415.222656 88.4725728,419.583984 C93.017983,423.945312 101.51068,427.036208 104.222573,428.046143 C103.539357,430.181769 97.473773,431.164003 93.5162379,432.062794 C70.9428539,424.908111 71.6195807,395.865071 72.6360045,394.224213 Z",
      "id": "girl3_left_shoe_6",
      "fill": "#6D8C4A",
      "transform": "translate(88.236286, 412.271875) scale(-1, 1) translate(-88.236286, -412.271875) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78.4634155,397 C76.2515014,397 65.8981585,397 63.0434936,397 C63.1645874,401.207275 62.494199,436.388112 63.1645874,443.210938 C68.7325185,443.210938 111.879111,443.210938 118.877712,443.210938 C119.247211,440.14087 121.108131,431.203427 108.116876,427.465242 C106.768898,428.503277 105.313552,429.608837 100.624569,431.203427 C78.3940796,426.232422 80.6919213,400.688228 78.4634155,397 Z",
      "id": "girl3_eft_shoe_5",
      "fill": "#80A259",
      "transform": "translate(91.021747, 420.105469) scale(-1, 1) translate(-91.021747, -420.105469) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M100.904115,438.943197 C97.3170686,438.943197 66.052665,438.900386 60.8210519,438.900386 C60.858616,439.419877 60.858616,440.86511 60.8210519,443.236084 C98.7636275,443.264624 118.167861,443.278895 119.033753,443.278895 C119.332305,440.798305 120.551699,432.284289 110.383117,428.350919 C107.58589,427.520181 101.293452,432.775964 100.904115,438.943197 Z",
      "id": "girl3_left_shoe_4",
      "fill": "#CDF1A5",
      "transform": "translate(90.029544, 435.771527) scale(-1, 1) translate(-90.029544, -435.771527) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M79.1843452,427.513343 C80.0873308,426.026122 85.9015481,423.518416 88.0254684,423.213991 C88.9091613,423.087329 89.8238904,423.829053 89.6997456,424.729312 C87.0281159,425.250636 81.9325169,427.752825 81.0505016,428.750597 C80.1684863,429.748369 78.2813595,429.000564 79.1843452,427.513343 Z",
      "id": "girl3_left_shoe_3",
      "fill": "#CDF1A5",
      "transform": "translate(84.328372, 426.202587) scale(-1, 1) translate(-84.328372, -426.202587) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M86.2055875,422.996753 C87.1085732,421.509532 92.9227904,419.001825 95.0467107,418.6974 C95.9304036,418.570739 96.8451327,419.312462 96.7209879,420.212722 C94.0493582,420.734046 88.9537592,423.236235 88.0717439,424.234007 C87.1897286,425.231779 85.3026018,424.483974 86.2055875,422.996753 Z",
      "id": "girl3_left_shoe_2",
      "fill": "#CDF1A5",
      "transform": "translate(91.349614, 421.685997) scale(-1, 1) translate(-91.349614, -421.685997) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M90.2418741,416.984118 C91.1448598,415.496897 96.9590771,412.98919 99.0829974,412.684765 C99.9666903,412.558104 100.26545,413.566686 100.141305,414.466946 C97.469675,414.98827 92.9900459,417.2236 92.1080306,418.221372 C91.2260153,419.219144 89.3388885,418.471339 90.2418741,416.984118 Z",
      "id": "girl3_left_shoe_1",
      "fill": "#CDF1A5",
      "transform": "translate(95.085653, 415.675021) scale(-1, 1) translate(-95.085653, -415.675021) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.1875,127.575195 C76.0742187,121.15625 103.271484,122.307617 116.945313,132.685547 C121.349565,136.028212 130.730469,169.469727 115.453125,194.431641 C133.447266,206.44987 143.596354,237.933373 145.900391,288.88215 C133.563802,293.335717 112.762695,295.5625 83.4970703,295.5625 C54.2314453,295.5625 33.4303385,293.335717 21.09375,288.88215 C21.8170573,243.257592 32.4306641,211.774089 52.9345703,194.431641 C48.4960938,190.916992 38.1162109,179.790039 39.5537109,164.436523 C41.6541693,142.002144 56.7981475,130.06635 62.1875,127.575195 Z",
      "id": "girl3_dress",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M109.974121,235.438232 C109.823768,238.863881 108.462836,240.758517 106.036526,244.726587 C103.205623,249.356345 103.20797,257.819263 100,264.869851 C100.790946,266.539763 105.981817,263.610025 107.120442,260.772243 C108.259068,257.93446 109.128122,255.626639 109.513393,254.911927 C109.898664,254.197215 110.789916,254.276563 111.037862,254.971576 C111.285807,255.666589 111.066629,280.633285 111.582664,281.87412 C112.098699,283.114955 115.201785,283.260807 115.783556,282.012683 C116.365327,280.764558 117.020686,261.026571 117.302227,260.506995 C117.583768,259.987419 118.256832,260.264164 118.534827,260.547651 C118.812822,260.831138 117.53821,281.896976 117.972837,282.696801 C118.407464,283.496626 121.618838,283.466431 121.989582,282.829289 C122.360325,282.192147 123.25457,261.180989 123.620815,260.715407 C123.98706,260.249825 124.691521,260.326551 124.964908,260.759741 C125.238296,261.192931 123.703122,281.403495 124.170718,282.289325 C124.638315,283.175155 127.746611,283.291415 128.065231,282.417782 C128.383852,281.544148 129.769254,261.214171 130.081283,260.928499 C130.393312,260.642828 130.797371,260.683837 131.074446,260.961258 C131.35152,261.238679 131.09446,276.448579 131.559996,277.291049 C132.025532,278.133519 134.371124,278.406322 134.755617,277.396453 C135.14011,276.386585 134.848538,239.278856 134.970568,237.224091 C135.377243,230.376452 130.887939,223.074219 123.282349,223.008667 C115.676758,222.943115 110.296991,228.081936 109.974121,235.438232 Z",
      "id": "girl3_left_hand",
      "fill": "#AFD485"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M122.5,179 L122.5,179 L122.5,179 C129.403559,179 135,184.596441 135,191.5 L135,235.5 L135,235.5 C135,242.403559 129.403559,248 122.5,248 L122.5,248 L122.5,248 C115.596441,248 110,242.403559 110,235.5 L110,191.5 L110,191.5 C110,184.596441 115.596441,179 122.5,179 Z",
      "id": "girl3_left_arm_bottom",
      "fill": "#AFD485"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "girl3_left_arm_top",
      "fill": "#AFD485",
      "x": "110",
      "y": "130",
      "width": "25",
      "height": "74",
      "rx": "12.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.0839844,118.428711 C78.5400391,115.759766 85.6044922,115.833008 90.0849609,118.428711 C89.9394531,123.30957 88.8798828,125.150391 92.2167969,127.822266 C88.3427734,133.892578 75.7128906,134.130136 71.8027344,127.822266 C74.3476562,126.016602 74.6376953,121.961914 74.0839844,118.428711 Z",
      "id": "girl3_neck",
      "fill": "#AFD485"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M80,30.1757812 C114.763454,30.3230543 121.804687,55.9535894 121.482422,73.4770269 C138.401367,71.9740972 125.806641,105.993628 113.334961,100.209449 C113.334961,105.55957 102.900391,120.638672 80,120.361328 C57.0996094,120.083984 43.3496094,101.334961 45.0673828,77.8413226 C46.7851562,54.3476843 50.9550781,30.0527344 80,30.1757812 Z",
      "id": "girl3_face",
      "fill": "#AFD485"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M72.0058221,110.127395 C73.6884111,110.548229 83.1529745,110.653437 86.3078289,110.022187 C87.990418,109.706562 84.2045926,112.862814 77.8948837,112.862814 C71.5851748,112.862814 72.0058221,110.127395 72.0058221,110.127395 Z",
      "id": "girl3_mouth_bottom",
      "fill": "#94B96B",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71,109.525002 C71,108.157293 72.0516181,107 77.5200325,107 C81.3058579,107 87.4052431,108.893752 90.4549358,108.052084 C91.0859066,107.841667 91.0859066,108.36771 90.2446121,108.683335 C86.353625,110.051044 82.5677996,110.051044 76.7838998,110.051044 C72.9980745,109.945836 71,109.525002 71,109.525002 Z",
      "id": "girl3_mouth_top",
      "fill": "#94B96B",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M75.646656,82.6271226 C75.646656,80.5496094 80.9925484,80.3675511 80.9951755,82.6271226 C80.9978027,84.8866942 82.7143519,96.6771337 80.9978027,98.7722485 C79.2812534,100.867363 74.2352448,100.165401 73.4543383,98.7722485 C72.6734319,97.3790957 72.820681,95.1071767 74.5146372,94.4743076 C76.2085934,93.8414384 75.646656,84.7046359 75.646656,82.6271226 Z",
      "id": "girl3_nose",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,84.6220095 C90.8152039,76.8563005 103.335453,75.6711235 105.216984,82.3958788 C105.225916,91.4764433 90.0465135,92.2784741 88,84.6220095 Z",
      "id": "girl3_left_eye_whites",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "girl3_left_pupil",
      "fill": "#6D8C4A",
      "cx": "94.304246",
      "cy": "84.304246",
      "r": "4.30424601"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68.216988,84.6220095 C65.4017841,76.8563005 52.8815353,75.6711235 51.0000039,82.3958788 C50.9910718,91.4764433 66.1704745,92.2784741 68.216988,84.6220095 Z",
      "id": "girl3_right_eye_whites",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "girl3_right_pupil",
      "fill": "#6D8C4A",
      "cx": "57.304246",
      "cy": "84.304246",
      "r": "4.30424601"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88.0959599,70.9515376 C90.2506474,69.7840087 101.590328,69.5855091 104.076646,70.9515376 C106.562963,72.3175661 104.742507,74.6634619 103.011266,74.132317 C101.280026,73.601172 91.0002622,73.4925047 89.1613389,74.132317 C87.3224156,74.7721293 85.9412724,72.1190665 88.0959599,70.9515376 Z",
      "id": "girl3_left_brow",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68.1970857,70.9515376 C66.0423982,69.7840087 54.702718,69.5855091 52.2164,70.9515376 C49.7300821,72.3175661 51.5505381,74.6634619 53.2817791,74.132317 C55.01302,73.601172 65.2927833,73.4925047 67.1317066,74.132317 C68.9706299,74.7721293 70.3517732,72.1190665 68.1970857,70.9515376 Z",
      "id": "girl3_right_brow",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M53.6339433,50.9883151 C57.5459606,59.6736842 66.1582045,68.4828886 79.4706751,77.4159283 L77.8777205,68.5339661 L85.9769852,77.4159283 L85.9769852,65.8650781 L92.8911799,77.4159283 L94.1677484,68.5339661 L101.094069,77.4159283 L101.094069,68.5339661 L109.30957,77.4159283 L109.30957,68.5339661 L115.446289,81.0273603 L116.871094,73.2998047 L123.941406,86.484375 L126.536133,75.0244141 C129.217118,61.2453811 127.454748,49.7574253 121.249023,40.5605469 C111.940436,26.7652292 95.8535156,23.1689453 80,24.4648437 C64.1464844,25.7607422 44.4455165,38.7964131 41.7711166,56.270001 C39.9881833,67.9190596 41.0778241,76.1715127 45.0400391,81.0273603 C44.9148788,68.6666204 47.7795136,58.6536053 53.6339433,50.9883151 Z",
      "id": "girl3_hair",
      "fill": "#80A259"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b907f81","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_3/svg/background/girl3.vue
// module id = 718
// module chunks = 1